import { toBig } from "@tradingApp/components/Trading/helpers/big";
import { numberIsFinite } from "@tradingApp/helpers/numbers/numberIsFinite";
import type { BigSource, RoundingMode } from "big.js";

interface PercentageFormatParams {
  percentage?: BigSource | null | undefined;
  fallBack?: string;
  withSign?: boolean;
  round?: RoundingMode;
}

export function percentageFormat(params: PercentageFormatParams): string {
  const { percentage, withSign = false, fallBack, round } = params;
  if (percentage === undefined || percentage === null) {
    return fallBack ? fallBack : "-";
  }

  const percentageBig = toBig(percentage);

  if (withSign) {
    return percentageBig.gt(0)
      ? `+${percentageBig.toFixed(2)}%`
      : `${percentageBig.toFixed(2)}%`;
  }

  return `${percentageBig.toFixed(2, round)}%`;
}

export function percentageNumberFromNumber(
  sourceValue: number | string,
  targetValue: number | string,
): number {
  const sourceValueNumber = numberIsFinite(sourceValue)
    ? sourceValue
    : Number.parseFloat(sourceValue);

  const targetValueNumber =
    typeof targetValue === "string"
      ? Number.parseFloat(targetValue)
      : targetValue;

  return ((targetValueNumber - sourceValueNumber) / sourceValueNumber) * 100;
}
